import React from "react";
import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const LearningPath = ({ svgProps, pathProps }: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };

  return (
    <svg {...mergedSvgProps}>
      <path
        d="M0 18V14H15.2L25.2 4H20V0H32V12H28V6.8L16.8 18H0ZM20 32V28H25.2L18.8 21.7L21.7 18.8L28 25.2V20H32V32H20Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default LearningPath;
